import anchorme from 'anchorme';

export class WithLinksValueConverter {
  toView(value: string) {
    return value == null ? value : anchorme({ input: value, options: { attributes: { target: '_blank' } } });
  }
}
